import React, { useState } from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { SendModal } from "./SendModal";

export default function SendCancelledPo({ purchaseOrder, onClose }) {
  const [visible, setVisible] = useState(false);

  const openModal = () => setVisible(true);

  const closeModal = () => {
    setVisible(false);
    onClose();
  };

  return (
    <React.Fragment>
      <DropDownItem onClick={openModal}>
        <Icon name="envelope-o" fixed /> &nbsp;Send Cancellation Notice
      </DropDownItem>
      <SendModal
        purchaseOrder={purchaseOrder}
        visible={visible}
        close={closeModal}
      />
    </React.Fragment>
  );
}

SendCancelledPo.propTypes = {
  purchaseOrder: PropTypes.instanceOf(Map).isRequired,
  onClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/SendCancelledPo/SendCancelledPo.jsx